import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import { Card, CardBody, CardTitle } from 'reactstrap';

const ManageLocation = () => {
  const [locations, setLocations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    if (locations.length) {
      $('#locationTable').DataTable();
    }
  }, [locations]);

  const fetchLocations = async () => {
    try {
      const response = await api.get('/location/get-all');
      setLocations(response.data.data);
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/locations/${id}`);
      setLocations(locations.filter(location => location.id !== id));
      alert(`Location with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting location:', error);
      if (error.response && error.response.status === 409) {
        alert('This location is associated with an itinerary and cannot be deleted. Please update or remove the related itinerary first.');
      } else {
        alert('An unexpected error occurred while deleting the location. Please try again later.');
      }
    }
  };

  const handleCreateLocationClick = () => {
    navigate('/create-location');
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag='h5' className='mb-3'> Location List </CardTitle>
      <Card>
        <CardBody>
          <div>
            <button className='btn btn-success btn-sm create-button' onClick={handleCreateLocationClick}>
              <FaPlus className='me-2' />
              Add Location
            </button>
          </div>
          <table id="locationTable" className='table table-bordered dataTable no-footer'>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Location Name</th>
                <th>Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {locations.map((location, index) => (
                <tr key={location.id}>
                  <td>{index + 1}</td>
                  <td>{location.location}</td>
                  <td>
                    <img
                      style={{  width: '100px', objectFit: 'cover', borderRadius: '5px' }}
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${location.image_path}`}
                      alt="Location"
                    />
                  </td>
                  <td className='text-center align-middle'>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                      <FaEdit style={{ cursor: 'pointer', color: '#34c38f' }} onClick={() => navigate(`/update-location/${location.id}`)} />
                      <FaTrash style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(location.id)} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
  );
};

export default ManageLocation;
